<template>
  <div id="defaultHeader">
    <div class="defaultHeader clearBox" :class="{'noTransparent': isShowHeaderBg || isPermanentShowHeaderBg}">
      <div @click="toGoRoute(menuList[0])" v-if="isShowHeaderBg || isPermanentShowHeaderBg" class="defaultHeader-logoBox clearBox">
        <img class="defaultHeader-logoBox-li1" src="~@/assets/images/defaultHeader/img_010.png"/>
        <img class="defaultHeader-logoBox-li2" src="~@/assets/images/defaultHeader/img_011.png"/>
      </div>
      <div @click="toGoRoute(menuList[0])" v-else class="defaultHeader-logoBox clearBox">
        <img class="defaultHeader-logoBox-li1" src="~@/assets/images/defaultHeader/img_001.png"/>
        <img class="defaultHeader-logoBox-li2" src="~@/assets/images/defaultHeader/img_002.png"/>
      </div>
      <div class="defaultHeader-languageBox">
        <div class="languageBox-tip clearBox" @click="isShowLanguageOption=!isShowLanguageOption">
          <img class="languageBox-tip-logo" :src="nowChooseLanguage.icon"/>
          <div class="languageBox-tip-content">{{ nowChooseLanguage.label }}</div>
          <img v-if="isShowHeaderBg || isPermanentShowHeaderBg" class="languageBox-tip-icon" :class="{'rotate': isShowLanguageOption}" src="~@/assets/images/defaultHeader/img_009.png"/>
          <img v-else class="languageBox-tip-icon" :class="{'rotate': isShowLanguageOption}" src="~@/assets/images/defaultHeader/img_006.png"/>
        </div>
        <div v-if="isShowLanguageOption" class="languageBox-option">
          <template v-for="(item, index) in languageOption">
            <div class="option-item clearBox" :key="index" @click="toChooseLanguage(item, index)">
              <img class="option-item-logo" :src="item.icon"/>
              <div class="option-item-content">{{ item.label }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="defaultHeader-navBox">
        <template v-for="(item, index) in menuList">
          <div
            class="navBox-li"
            :class="{'active': isActive(item.name)}"
            :key="index"
            @click="toGoRoute(item)"
            @mouseenter="mouseEnterNav(index)"
            @mouseleave="mouseLeaveNav(index)">
            {{ nowChooseLanguage.type==1?item.title:'' }}
            {{ nowChooseLanguage.type==2?item.englishTitle:'' }}
            {{ nowChooseLanguage.type==3?item.koreanTitle:'' }}
            <div v-if="item.children" class="navBox-li-bg"></div>
            <div v-if="item.children && item.isShowChildren" class="navBox-li-option">
              <template v-for="(item2, index2) in item.children">
                <div class="option-item" :key="index2" @click.stop="toGoRoute(item2)">
                  {{ nowChooseLanguage.type==1?item2.title:'' }}
                  {{ nowChooseLanguage.type==2?item2.englishTitle:'' }}
                  {{ nowChooseLanguage.type==3?item2.koreanTitle:'' }}
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="defaultScreenHeader clearBox">
      <div @click="toGoRoute(menuList[0])" class="defaultScreenHeader-logoBox">
        <img class="logoBox-li1" src="~@/assets/images/defaultHeader/img_010.png"/>
        <img class="logoBox-li2" src="~@/assets/images/defaultHeader/img_011.png"/>
      </div>
      <div class="defaultScreenHeader-smallMenu">
        <div class="smallMenu-switchBtn" @click="isSwitchMenu=!isSwitchMenu">
          <img v-if="!isSwitchMenu" class="smallMenu-switchBtn-icon" src="~@/assets/images/defaultHeader/img_014.png"/>
          <img v-else class="smallMenu-switchBtn-icon" src="~@/assets/images/defaultHeader/img_012.png"/>
        </div>
        <div v-if="isSwitchMenu" class="smallMenu-contentMenu">
          <template v-for="(item, index) in menuList">
            <div class="contentMenu-li" :key="index" @click="item.isShowChildren=!item.isShowChildren; !item.children ? toGoRoute(item) : null">
              <div class="contentMenu-li-title">
                {{ nowChooseLanguage.type==1?item.title:'' }}
                {{ nowChooseLanguage.type==2?item.englishTitle:'' }}
                {{ nowChooseLanguage.type==3?item.koreanTitle:'' }}
                <img v-if="item.children" class="title-icon" :class="{'rotate': item.isShowChildren}" src="~@/assets/images/defaultHeader/img_013.png"/>
              </div>
              <div v-if="item.children && item.isShowChildren" class="contentMenu-li-childBox">
                <template v-for="(item2, index2) in item.children">
                  <div class="childBox-li" :key="index2" @click="toGoRoute(item2)">
                    {{ nowChooseLanguage.type==1?item2.title:'' }}
                    {{ nowChooseLanguage.type==2?item2.englishTitle:'' }}
                    {{ nowChooseLanguage.type==3?item2.koreanTitle:'' }}
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div class="contentMenu-li" key="100">
            <div class="contentMenu-li-title" @click="isShowLanguageOption=!isShowLanguageOption">{{ nowChooseLanguage.type==1?"语言":""}}{{ nowChooseLanguage.type==2?"Language":""}}{{ nowChooseLanguage.type==3?"언어":""}}
              <img class="title-icon" :class="{'rotate': isShowLanguageOption}" src="~@/assets/images/defaultHeader/img_013.png"/>
            </div>
            <div v-if="isShowLanguageOption" class="contentMenu-li-childBox">
              <template v-for="(item, index) in screenLanguageOption">
                <div class="childBox-li" :key="index" @click="toChooseScreenLanguage(item)">
                  <img class="childBox-li-logo" :src="item.icon"/>
                  <div class="childBox-li-content">{{ item.label }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import notice from "@/pages/notice";

export default {
  name: 'defaultHeader',
  data(){
    return {
      menuList: [
        {
          title: '首页',
          englishTitle: 'Home',
          koreanTitle: '홈',
          name: 'home',
          route: '/',
          isShowChildren: false,
        },{
          title: '关于我们',
          englishTitle: 'About Us',
          koreanTitle: '회사 소개',
          name: 'companyIntroduction',
          route: '/companyIntroduction',
          isShowChildren: false,
          children: [
            {
              title: '公司介绍',
              englishTitle: 'Greetings',
              koreanTitle: '인사말',
              name: 'companyIntroduction',
              route: '/companyIntroduction',
            }, {
              title: '发展历程',
              englishTitle: 'Our Journey',
              koreanTitle: '연혁',
              name: 'developmentHistory',
              route: '/developmentHistory',
            }, {
              title: '自有仓库',
              englishTitle: 'Warehouse',
              koreanTitle: '창고',
              name: 'warehouse',
              route: '/warehouse',
            }
          ]
        },{
          title: '主营产品',
          englishTitle: 'Main Products',
          koreanTitle: '주요 제품',
          name: 'dominantIndustry',
          route: '/dominantIndustry',
          isShowChildren: false,
        },{
          title: '合作品牌',
          englishTitle: 'Line Card',
          koreanTitle: '취급 브랜드',
          name: 'coBranding',
          route: '/coBranding',
          isShowChildren: false,
        },{
          title: '动态通告',
          englishTitle: 'News & Updates',
          koreanTitle: '공지사항',
          name: 'notice',
          route: '/notice',
          isShowChildren: false,
        },{
          title: '联系我们',
          englishTitle: 'Contact Us',
          koreanTitle: '문의하기',
          name: 'contactUs',
          route: '/contactUs',
          isShowChildren: false,
        }
      ],
      isShowLanguageOption: false, // 语言切换显示选项
      nowChooseLanguage: {
        type: 1,
        label: '中国',
        icon: require('@/assets/images/defaultHeader/img_003.png')
      },
      languageOption: [
        {
          type: 2,
          label: 'English',
          icon: require('@/assets/images/defaultHeader/img_004.png')
        },{
          type: 3,
          label: '한국어',
          icon: require('@/assets/images/defaultHeader/img_005.png')
        }
      ],
      screenLanguageOption: [
        {
          type: 1,
          label: '中国',
          icon: require('@/assets/images/defaultHeader/img_003.png')
        },
        {
          type: 2,
          label: 'English',
          icon: require('@/assets/images/defaultHeader/img_004.png')
        },{
          type: 3,
          label: '한국어',
          icon: require('@/assets/images/defaultHeader/img_005.png')
        }
      ],

      isSwitchMenu: false, // 切换菜单
    }
  },
  computed: {
    isShowHeaderBg() {
      return this.$store.getters.isShowHeaderBg
    },
    isPermanentShowHeaderBg(){
      return this.$store.getters.isPermanentShowHeaderBg
    }
  },
  created() {
    this.initLanguage()
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)

    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    // 初始化语言模块
    initLanguage(){
      var that=this
      var storageLanguage=sessionStorage.getItem('nowChooseLanguage')
      if(storageLanguage){
        that.languageOption.some((item, index)=>{
          if(JSON.parse(storageLanguage).type==item.type){
            that.$set(that.languageOption, index, that.nowChooseLanguage);
          }
        })
        that.nowChooseLanguage=JSON.parse(storageLanguage)
      }else {
        sessionStorage.setItem('nowChooseLanguage', JSON.stringify(that.nowChooseLanguage))
      }
      that.$store.commit('SET_LANGUAGETYPE', that.nowChooseLanguage.type)
    },
    // 判断是否active
    isActive(name){
      var locationStr=this.$route.meta.name
      if(locationStr && name){
        if(locationStr.includes(name)){
          return true
        }
      }else {
        return false
      }
    },
    // 监听页面切换
    handleScroll(){
      var windowScrollY = window.scrollY
      var domHeight=document.getElementById("scrollHeader").offsetHeight
      if(windowScrollY>domHeight){
        this.$store.commit('SET_ISSHOWHEADERBG', true)
      }else {
        this.$store.commit('SET_ISSHOWHEADERBG', false)
      }
    },
    // 监听页面屏幕分辨率变化
    handleResize(){
      if(window.innerWidth<=1400){
        this.isSwitchMenu=false
      }
    },
    // 跳转路由
    toGoRoute(item){
      console.log("222", item, this.$route)
      if(!this.isActive(item.name)){
        this.$router.push({
          path: item.route
        })
        this.isSwitchMenu=false
      }else if(this.$route.path=='/noticeDetail'){
        this.$router.push({
          path: item.route
        })
        this.isSwitchMenu=false
      }else{
        window.location.reload()
      }
    },
    // 鼠标移入菜单
    mouseEnterNav(index){
      this.menuList[index].isShowChildren=true
    },
    // 鼠标移出菜单
    mouseLeaveNav(index){
      this.menuList[index].isShowChildren=false
    },
    // 选择切换语言
    toChooseLanguage(item, index){
      this.$set(this.languageOption, index, this.nowChooseLanguage);
      this.nowChooseLanguage=item
      sessionStorage.setItem('nowChooseLanguage', JSON.stringify(this.nowChooseLanguage))
      this.$store.commit('SET_LANGUAGETYPE', this.nowChooseLanguage.type)
      this.isShowLanguageOption=false
    },
    // 选择切换语言-小屏
    toChooseScreenLanguage(item){
      this.nowChooseLanguage=item
      sessionStorage.setItem('nowChooseLanguage', JSON.stringify(this.nowChooseLanguage))
      this.$store.commit('SET_LANGUAGETYPE', this.nowChooseLanguage.type)
      this.isShowLanguageOption=false
      this.isSwitchMenu=false
    }
  }
}
</script>

<style rel="stylesheet/scss" scoped lang="scss">
#defaultHeader{

  .defaultHeader{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    z-index: 1000;
    box-sizing: border-box;
    padding: vw(36) vw(50) vw(20);
    // min-width: 1920px;

    &-logoBox{
      float: left;

      &-li1{
        float: left;
        width: vw(178);
        height: vw(38);
        margin: 0 vw(35) 0 0;
      }

      &-li2{
        float: left;
        width: vw(226);
        height: vw(38);
      }
    }

    &-navBox{
      float: right;
      margin: 0 vw(40) 0 0;
      font-size: 0;
      opacity: 1;

      .navBox-li{
        display: inline-block;
        text-align: center;
        height: vw(38);
        line-height: vw(38);
        font-size: vw(18);
        color: #FFFFFF;
        margin: 0 vw(20);
        cursor: pointer;
        position: relative;

        &.active{
          font-weight: bold;
          &::after{
            content: '';
            width: 100%;
            height: vw(2);
            background-color: #FFFFFF;
            position: absolute;
            left: 0;
            bottom: vw(-5);
            z-index: 1;
          }
        }

        &:hover{
          font-weight: bold;

          &::after{
            content: '';
            width: 100%;
            height: vw(2);
            background-color: #FFFFFF;
            position: absolute;
            left: 0;
            bottom: vw(-5);
            z-index: 1;
          }
        }

        &-bg{
          position: absolute;
          width: vw(106);
          height: vw(25);
          bottom: vw(-24);
          left: 50%;
          transform: translateX(-50%);
          z-index: 1;
          opacity: 0;
        }

        &-option{
          border-radius: vw(6);
          color: #FFFFFF;
          padding: vw(28) vw(20);
          position: absolute;
          top: vw(60);
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          background-color: #ffffff;
          white-space: nowrap;
          box-sizing: border-box;

          .option-item{
            height: vw(18);
            line-height: vw(18);
            font-size: vw(18);
            color: #5F5F5F;
            margin: 0 0 vw(28) 0;
            font-weight: 400;

            &:hover{
              font-weight: bold;
            }

            &:last-child{
              margin: 0;
            }
          }
        }
      }
    }

    &-languageBox{
      float: right;
      margin: vw(10) 0 0 0;
      position: relative;
      width: vw(150);
      opacity: 1;

      .languageBox-tip{
        cursor: pointer;

        &-logo{
          float: left;
          width: vw(36);
          height: vw(24);
          margin: 0 vw(20) 0 0;
        }

        &-content{
          float: left;
          height: vw(24);
          line-height: vw(24);
          font-size: vw(18);
          color: #FFFFFF;
          margin: 0 vw(8) 0 0;
        }

        &-icon{
          float: left;
          width: vw(10);
          margin: vw(8) 0 0 0;
          transition: all 0.2s ease-in;

          &.rotate{
            transform: rotate(180deg);
          }
        }
      }

      .languageBox-option{
        border-radius: vw(6);
        color: #FFFFFF;
        padding: vw(24) 0 vw(24) vw(20);
        position: absolute;
        top: vw(60);
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        background-color: #ffffff;
        width: vw(144);
        box-sizing: border-box;
        box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);

        .option-item{
          margin: 0 0 vw(28) 0;
          white-space: nowrap;
          cursor: pointer;

          &-logo{
            float: left;
            width: vw(36);
            height: vw(24);
            margin: 0 vw(15) 0 0;
          }

          &-content{
            width: vw(84);
            text-align: center;
            height: vw(24);
            line-height: vw(24);
            font-size: vw(18);
            color: #5F5F5F;
          }

          &:hover{

            .option-item-content{
              font-weight: bold;
            }
          }

          &:last-child{
            margin: 0;
          }
        }
      }
    }

    &.noTransparent{
      background-color: #FFFFFF;
      box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);

      .navBox-li{
        color: #333333;

        &:hover{
          font-weight: bold;

          &::after{
            background-color: #333333;
          }
        }

        &-option{
          box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);
        }
      }

      .languageBox-tip{

        .languageBox-tip-content{
          color: #333333;
        }
      }
    }
  }
  .defaultScreenHeader{
    position: fixed;
    top: -100%;
    left: 0;
    width: 100vw;
    z-index: 1000;
    box-sizing: border-box;
    padding: 19px 25px;
    opacity: 0;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.15);


    &-logoBox{
      float: left;
      display: flex;
      justify-items: center;

      .logoBox-li1{
        width: 99px;
        height: 21px;
        margin: 0 33px 0 0;
      }

      .logoBox-li2{
        width: 138px;
        height: 21px;
      }
    }

    &-smallMenu{
      float: right;

      .smallMenu-switchBtn{
        width: 21px;
        height: 13px;

        &-icon{
          width: 100%;
        }
      }

      .smallMenu-contentMenu{
        position: absolute;
        left: 0;
        top: 59px;
        border-top: 1px solid #ECECEC;
        border-bottom: 1px solid #ECECEC;
        width: 100vw;
        background-color: #ffffff;
        padding: 7px 0 0 0;
        //overflow-y: auto;
        //max-height: calc( 100vh - 140px );

        &::-webkit-scrollbar{
          display: none;
        }

        .contentMenu-li{

          &-title{
            font-size: 13px;
            color: #202020;
            font-weight: bold;
            padding: 12px 25px;
            height: 13px;
            line-height: 13px;
            position: relative;

            .title-icon{
              width: 10px;
              height: 7px;
              position: absolute;
              top: 50%;
              right: 28px;
              z-index: 1;
              transform: translateY(-50%) rotate(0deg);
              transition: all 0.2s ease-in;

              &.rotate{
                transform:translateY(-50%) rotate(-180deg);
              }
            }
          }

          &-childBox{
            width: 100%;
            background-color: #FBFBFB;
            padding: 3px 33px;

            .childBox-li{
              font-size: 13px;
              color: #202020;
              padding: 9px 0;
              height: 13px;
              line-height: 13px;
              position: relative;
              display: flex;
              justify-items: center;

              &-logo{
                width: 19px;
                height: 13px;
                margin: 0 5px 0 0;
              }

              &:after{
                content: '';
                width: 4px;
                height: 4px;
                border-radius: 4px;
                background-color: #202020;
                position: absolute;
                top: 50%;
                left: -8px;
                z-index: 1;
                transform: translateY(-50%);
              }
            }
          }


        }

      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .defaultHeader{
    opacity: 0;
    display: none;
  }

  .defaultScreenHeader{
    opacity: 1 !important;
    position: relative !important;
    top: 0;
  }
}
</style>
